import timezones from "@/features/timezone/data/timezones.json";

export type TimezoneDatabaseName = (typeof timezones)[number]["name"];

/**
 * Returns the curated UTC offset string for the IANA timezone, e.g.
 * `"UTC+08:00"`. Returns `""` if the name is not in the curated list.
 */
export const getTimezoneOffset = (
  name: TimezoneDatabaseName | string,
): string => {
  return timezones.find((timezone) => timezone.name === name)?.offset ?? "";
};
